export const INTERVENTION_EVENTS = {
    CREATED: 'intervention.created',
    STATUS_CHANGED: 'intervention.status_changed',
    STATUS_FORCED: 'intervention.status_forced',
    PRIORITY_CHANGED: 'intervention.priority_changed',
    USER_ASSIGNED: 'intervention.user_assigned',
    USER_UNASSIGNED: 'intervention.user_unassigned',
    DOCUMENT_UPLOADED: 'intervention.document_uploaded',
    DOCUMENT_DELETED: 'intervention.document_deleted',
    DATE_CHANGED: 'intervention.date_changed',
    TECHNICIAN_ASSIGNED: 'intervention.technician_assigned',
    TECHNICIAN_REJECTED: 'intervention.technician_rejected',
    ASSIGNMENT_CANCELED: 'intervention.assignment_canceled',
    DISPUTE_REPORTED: 'intervention.dispute_reported',
    DISPUTE_UPDATED: 'intervention.dispute_updated',
    DISPUTE_RESOLVED: 'intervention.dispute_resolved',
    PUT_ON_HOLD: 'intervention.put_on_hold',
    RESUMED: 'intervention.resumed',
    REACTIVATED: 'intervention.reactivated',
    COMPLETED: 'intervention.completed',
    CANCELLED: 'intervention.cancelled',
    CLOSED: 'intervention.closed',
};
export const INVOICE_EVENTS = {
    CREATED: 'invoice.created',
    SENT: 'invoice.sent',
    PAID: 'invoice.paid',
    /** A mark-paid taken back (#1716): PAID -> SENT, `paidAt` cleared. */
    UNPAID: 'invoice.unpaid',
    PAYMENT_DECLARED: 'invoice.payment_declared',
};
export const QUOTE_EVENTS = {
    CREATED: 'quote.created',
    VALIDATED: 'quote.validated',
    SHARED: 'quote.shared',
    UNSHARED: 'quote.unshared',
    DECLINED: 'quote.declined',
    REVISION_REQUESTED: 'quote.revision_requested',
};
export const JOB_REPORT_EVENTS = {
    ARRIVAL_RECORDED: 'job_report.arrival_recorded',
    CREATED: 'job_report.created',
    SIGNED: 'job_report.signed',
    VALIDATED: 'job_report.validated',
};
export const NOTIFICATION_EVENTS = {
    FAILED: 'notification.failed',
};
